import { render, staticRenderFns } from "./TableRenderer.vue?vue&type=template&id=10310d46&scoped=true&"
import script from "./TableRenderer.vue?vue&type=script&lang=js&"
export * from "./TableRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10310d46",
  null
  
)

export default component.exports